import { render } from "./ProviderEmptyState.vue?vue&type=template&id=66794685&scoped=true"
import script from "./ProviderEmptyState.vue?vue&type=script&lang=js"
export * from "./ProviderEmptyState.vue?vue&type=script&lang=js"

import "./ProviderEmptyState.vue?vue&type=style&index=0&id=66794685&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66794685"]])

export default __exports__